import { Card, Dropdown } from "react-bootstrap";
import { FiChevronDown } from "react-icons/fi";

const LeftDetailsCard = () => {
  return (
    <Card className="custom-card">
      <Card.Body>
        <h6 className="section-title">Project Details</h6>

        {/* BOX */}
        <div className="details-box">
          
          <RowItem label="Client" value="EcoVision Enterprises" />

          <RowItem
            label="Project Total Cost"
            value="$1400"
            right
          />

          <RowItem label="Hours of Work" value="150 hrs" right />

          <RowItem label="Created on" value="14 Nov 2026" right />

          <RowItem label="Started on" value="15 Jan 2026" right />

          {/* Due Date with badge */}
          <div className="details-row">
            <span>Due Date</span>
            <div className="d-flex align-items-center gap-2">
              <span className="fw-medium">15 Nov 2026</span>
              <span className="due-badge">1</span>
            </div>
          </div>

          {/* Created By */}
          <div className="details-row">
            <span>Created by</span>
            <div className="d-flex align-items-center gap-2">
              <img
                src="/assets/img/profiles/avatar-02-1.jpg"
                alt=""
                className="avatar-sm"
              />
              <span className="fw-medium">Cameron</span>
            </div>
          </div>

          {/* Priority */}
          <div className="details-row">
            <span>Priority</span>

            <Dropdown>
              <Dropdown.Toggle className="priority-btn text-dark">
                <span className="dot red"></span>
                High
                <FiChevronDown size={14} />
              </Dropdown.Toggle>

              <Dropdown.Menu className="z-index">
                <Dropdown.Item>
                  <span className="dot red"></span> High
                </Dropdown.Item>
                <Dropdown.Item>
                  <span className="dot yellow"></span> Medium
                </Dropdown.Item>
                <Dropdown.Item>
                  <span className="dot green"></span> Low
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {/* TASKS */}
        <h6 className="section-title mt-3">Tasks Details</h6>

        <div className="task-box">
          <span className="task-label">Tasks Done</span>
          <h5 className="task-count">0 / 0</h5>

          <div className="progress-track">
            <div className="progress-fill"></div>
          </div>

          <p className="task-percent">0% Completed</p>
        </div>
      </Card.Body>
    </Card>
  );
};

const RowItem = ({ label, value, right }) => (
  <div className="details-row">
    <span>{label}</span>
    <span className={`fw-medium ${right ? "text-end" : ""}`}>
      {value}
    </span>
    <style>
     {

          `
          .custom-card {
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
}

/* Title */
.section-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
}

/* Box container */
.details-box {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

/* Row */
.details-row {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  border-bottom: 1px solid #eee;
  font-size: 13px;
}

.details-row:last-child {
  border-bottom: none;
}

/* Avatar */
.avatar-sm {
  width: 26px;
  height: 26px;
  border-radius: 50%;
}

/* Due badge */
.due-badge {
  background: #ef4444;
  color: #fff;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 6px;
}

/* Priority */
.priority-btn {
  background: #fff !important;
  border: 1px solid #ddd !important;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.dot.red { background: #ef4444; }
.dot.yellow { background: #f59e0b; }
.dot.green { background: #22c55e; }

/* Tasks */
.task-box {
  background: #f9fafb;
  border-radius: 8px;
  padding: 12px;
}

.task-label {
  font-size: 12px;
  color: #6b7280;
}

.task-count {
  font-size: 18px;
  font-weight: 600;
}

.progress-track {
  height: 4px;
  background: #e5e7eb;
  border-radius: 4px;
  margin: 8px 0;
}

.progress-fill {
  width: 0%;
  height: 100%;
  background: #f97316;
  border-radius: 4px;
}

.task-percent {
  font-size: 12px;
  color: #6b7280;
}

/* MOBILE */
@media (max-width: 1024px) {
  .custom-card {
    margin-top: 12px;
  }

  .details-row {
    flex-direction: row;
    font-size: 12px;
  }
}`
     }
    </style>
  </div>
);

export default LeftDetailsCard;